module.exports = __webpack_public_path__ + "static/media/HighAngelOfAether09.57249e65.jpg";